import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import { Button } from 'palette/Button';
import { OnChangeEvent } from 'palette/Types/events';
import { Dropdown } from './Dropdown';
import './styles/Pagination.scss';

type OnClickPayload = { nextPageIndex: number };

interface PaginationProps {
    labelPrevious: string;
    labelNext: string;
    dropdownLabel: string;
    currentPage: number;
    pageCount: number;
    onChange(payload: OnClickPayload, event: OnChangeEvent): void;
    isCustomStyle: boolean;
    hrefPrev?: string;
    hrefNext?: string;
    className?: string;
    buttonClassName?: string;
    hrefDropdown?: string;
}

export function Pagination({
    labelPrevious,
    labelNext,
    currentPage,
    pageCount,
    onChange,
    dropdownLabel,
    isCustomStyle,
    hrefPrev,
    hrefNext,
    className,
    buttonClassName,
    hrefDropdown,
}: PaginationProps) {
    const [block, BEMElement] = BEMBlock('palette-pagination');

    const handlePageSelection = (nextPageIndex: number, event: OnChangeEvent) => {
        const hasValueChanged = nextPageIndex !== currentPage;
        const isValidPage = nextPageIndex >= 1 && nextPageIndex <= pageCount;

        if (hasValueChanged && isValidPage) { onChange({ nextPageIndex }, event); }
    };

    const handlePreviousClick: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = (event) => {
        event.preventDefault();
        handlePageSelection(currentPage - 1, event);
    };

    const handleNextClick: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = (event) => {
        event.preventDefault();
        handlePageSelection(currentPage + 1, event);
    };

    const handleDropdownChange = (value: number, event: OnChangeEvent) => {
        event.preventDefault();
        handlePageSelection(value, event);
    };

    if (pageCount === 1) { return null; }

    return (
        <div className={classNames(block, className)}>
            <Button
                className={classNames(BEMElement('button-previous'), buttonClassName)}
                disabled={currentPage === 1}
                href={hrefPrev}
                label={labelPrevious}
                size="medium"
                theme="secondary"
                onClick={handlePreviousClick}
            />
            <div className={BEMElement('dropdown')}>
                <Dropdown
                    currentPage={currentPage}
                    isCustomStyle={isCustomStyle}
                    label={dropdownLabel}
                    pageCount={pageCount}
                    seoLink={hrefDropdown}
                    onChange={handleDropdownChange}
                />
            </div>
            <Button
                className={classNames(BEMElement('button-next'), buttonClassName)}
                disabled={currentPage === pageCount}
                href={hrefNext}
                label={labelNext}
                size="medium"
                theme="secondary"
                onClick={handleNextClick}
            />
        </div>
    );
}

export default null;
